

import React from "react";
import '../styles.scss';
import './section4.scss';

/**
 * Section 4
 * h2 monitor text
 * p tag
 * h2 coming soon text
 * brand_logos images
 * hr line
 */
const Section4: React.FC = () => {

    return (
        <>
            <section className=" ">
                <div className="container  text-center pt-5 pb-3 padBox bg-light">
                <h2 className="font_nun_bold lh-sm">Monitor Your Journey to Wellness</h2>
                <p className="px_6 mb-4 p0_10 font_nun_reg fw-bold lh-sm wh-pw ">
                    After each Dhyana session, you'll receive a personalized relaxation score, reflecting 
                    your mental calm and focus. View your progress through a secure data 
                    dashboard available online or in your VR headset.
                </p>
                <h2 className="font_nun_bold mb-4">coming soon</h2>

                <div className="d-flex brand_logos mb-2">
                    <img src="assets/images/Meta_2.png" alt="" />
                    <div className=""></div>
                    <img src="assets/images/Ajna_2.png" alt="" />
                    <div className=""></div>
                    <img src="assets/images/Pico_2.png" alt="" />



                </div>


                <div className="clearfix"></div>
                </div>


            </section>
            <div className="container text-center bg-light pt-5">
                <hr className="half_line mb-5 " />

                <div className="clearfix"></div>
            </div>

        </>)
}

export default Section4;